import { CommonModule } from '@angular/common'
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core'
import { TranslocoModule } from '@jsverse/transloco'
import { Utilities } from 'src/app/_models/class/utilities'

@Component({
  selector: 'wrapper-modal',
  standalone: true,
  imports: [TranslocoModule, CommonModule],
  templateUrl: './wrapper-modal.component.html',
})
export class WrapperModalComponent {
  @ViewChild('modalContainer') modalContainer!: ElementRef

  @Input() title?: string
  @Input() confirmText?: string
  @Input() cancelText?: string

  @Output() confirm = new EventEmitter<any>()
  @Output() close = new EventEmitter<boolean>()

  Utilities = Utilities

  ngAfterViewInit() {
    this.setFocusOnModal()
  }

  setFocusOnModal() {
    if (this.modalContainer) {
      this.modalContainer.nativeElement.focus()
    }
  }

  onConfirm() {
    this.confirm.emit()
    this.close.emit(true)
  }

  onClose() {
    this.close.emit(true)
  }
}
